// extracted by mini-css-extract-plugin
export default {"searchWrapper":"Search_searchWrapper__cobeO","AnnosPage":"Search_AnnosPage__ANecs"};